import type { PayloadAction } from '@reduxjs/toolkit'
import { createReducer } from '@reduxjs/toolkit'
import type { RootState } from '@/redux/interfaces'
import { reducerManager } from '@/redux/reducerManager'
import type { IDocumentsResponse } from '@/services/documents/interfaces'
import { fetchDocuments, setDocuments, setPending } from './actions'
import type { IDocumentsState, IFetchDocumentsPayload } from './interfaces'

const initialState: IDocumentsState = {
  isFetching: false,
  documents: [],
  types: [],
  pagination: {
    total: 0,
    offset: 0,
    limit: 0,
  },
}

const reducer = createReducer(initialState, {
  [setPending.type]: (state, { payload }: PayloadAction<boolean>) => {
    state.isFetching = payload
  },
  [fetchDocuments.type]: (state, { payload }: PayloadAction<IFetchDocumentsPayload>) => {
    state.isFetching = !payload.shouldNotShowLoadingState
  },
  [setDocuments.type]: (state, { payload }: PayloadAction<IDocumentsResponse>) => {
    const { types, documents, pagination } = payload
    state.isFetching = false
    state.documents = documents
    state.types = types
    state.pagination = pagination
  },
})

reducerManager.add('documents', reducer)

export const isFetching =
  () =>
  (state: RootState): boolean =>
    state.documents.isFetching
export const getDocuments = () => (state: RootState) => state.documents.documents
export const getTypes = () => (state: RootState) => state.documents.types
export const getPagination = () => (state: RootState) => state.documents.pagination
